import * as Sentry from '@sentry/vue'
import type { InvalidApplication } from '#/infrastructure/implementation/application/parseApplications'

const STORAGE_PREFIX = 'invalidApplicationReported:'
const reportedInMemory = new Set<string>()

const wasReported = (key: string): boolean => {
  if (reportedInMemory.has(key)) return true
  try {
    return sessionStorage.getItem(STORAGE_PREFIX + key) !== null
  } catch {
    return false
  }
}

const markReported = (key: string) => {
  reportedInMemory.add(key)
  try {
    sessionStorage.setItem(STORAGE_PREFIX + key, '1')
  } catch {
    // sessionStorage can be unavailable (private mode, blocked site data); the in-memory set still dedupes
  }
}

export function reportInvalidApplication(invalid: InvalidApplication) {
  const key = `${invalid.applicationId ?? `index-${invalid.index}`}|${invalid.issues}`
  if (wasReported(key)) return
  markReported(key)

  Sentry.withScope((scope) => {
    scope.setLevel('warning')
    scope.setTag('api.endpoint', 'v1/application')
    scope.setFingerprint(['invalid-api-item', 'v1/application'])
    scope.setExtras({ ...invalid })
    Sentry.captureMessage('Invalid item in the v1/application response')
  })
}
